export enum OkCancelDialogActions {
    OK = 'ok',
    ALERTNATIVE_OK = 'ok2',
    CANCEL = 'cancel',
}
